var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M16.855 5H8.85498C7.19813 5 5.85498 6.34315 5.85498 8V16C5.85498 17.6569 7.19813 19 8.85498 19H16.855C18.5118 19 19.855 17.6569 19.855 16V8C19.855 6.34315 18.5118 5 16.855 5ZM8.85498 4C6.64584 4 4.85498 5.79086 4.85498 8V16C4.85498 18.2091 6.64584 20 8.85498 20H16.855C19.0641 20 20.855 18.2091 20.855 16V8C20.855 5.79086 19.0641 4 16.855 4H8.85498Z"}));
}

SVGIcon.defaultProps = {"viewBox":"0 0 25 24"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
